import { CardData } from './types';

export default class CardConfig implements CardData {
    Url: string;
    Title: string;
    Description: string;
    ImageUrl: string;
  
  constructor(
    url: string,
    title: string,
    description: string,
    imageUrl: string 
   
  ) {    
    //cardcount must be multiples of 3
    this.Url = url ? url : '';
    this.Title = title ? title : '';
    this.Description = description ? description : '';
    this.ImageUrl = imageUrl ? imageUrl : '';

  }
}
